module.exports = __webpack_public_path__ + "img/mobility_warranty.46e18211.svg";